import { checkout_entrance } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout/logic/actions.js?1733898722549';
import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898722549';
import { get_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/get_stock.js?1733898722549';
import { cart } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/cart.js?1733898722549';
import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898722549';
import { logger } from '@wyvr/generator/universal.js';

/**
 * This function attempts to make a direct purchase of a product.
 *
 * @async
 * @function direct_purchase
 * @param {Object} [product] An object representing the product to be purchased. It should at least contain 'sku' and 'stock' information.
 * @param {string} [action=''] The action to be performed after the purchase, default is an empty string.
 * @param {boolean} [show_messages=true] A flag indicating whether to show messages during the process or not, default is true.
 * @returns {Promise<boolean>} Returns false if SKU is not found or item is out of stock, otherwise initiates checkout process and returns whatever `checkout_entrance()` function returns.
 */
export async function direct_purchase(product, action = '', show_messages = true) {
    if (product) {
        const sku = get_attribute_value(product, 'sku');
        if (!sku) {
            if (show_messages) {
                messages.push(window.__('checkout.error_entrance'));
            }
            return false;
        }
        const in_stock = get_stock(product)?.is_in_stock;
        if (!in_stock) {
            if (show_messages) {
                messages.push(window.__('checkout.error_out_of_stock'));
            }
            return false;
        }

        try {
            await cart.update_item(sku, 1);
        } catch (e) {
            logger.error('direct_purchase', sku, action, e);
            if (show_messages) {
                messages.push(window.__('checkout.error_entrance'));
            }
            return false;
        }
    }
    return checkout_entrance(action);
}
